global.$ = require('jquery')
global.Popper = require('popper.js')
require('bootstrap')
require('velocity-animate')
require('velocity-animate/velocity.ui')



// WEBPACK FOOTER //
// ./src/vendor.js